export default __webpack_public_path__ + "static/media/video-on.b1ab45ef.svg";